import React from "react";
import { formatDateTime } from "../utils";

const LogFlowTimeline = ({ logs, variant }) => {
  const embedded = variant === "embedded";

  return (
    <section
      className={`logs-flow-card${embedded ? " logs-flow-card--embedded" : ""}`}
    >
      <div className="logs-flow-header">
        <h3>Flow timeline</h3>
        <p>
          {embedded
            ? "Backend booking log events (oldest at bottom, newest at top)."
            : "First event starts at the bottom, latest event appears on top."}
        </p>
      </div>

      <div className="logs-flow-body">
        {logs.map((log, index) => (
          <div key={log.id} className="logs-flow-item">
            <div className="logs-flow-dot" />
            <div className="logs-flow-content">
              <strong>{log.title}</strong>
              <span>
                Step {index + 1} · {formatDateTime(log.eventTime)}
              </span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default LogFlowTimeline;
